var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"flex w-full h-full justify-center py-2 px-4 text-sm font-medium | focus:outline-none | transition duration-150 ease-in-out",class:[
            {
                'bg-blue-500 border-transparent text-white cursor-default': _vm.primary,
                'bg-white border-gray-300 text-gray-700': !_vm.primary,
                'opacity-50 cursor-not-allowed': _vm.disabled,
            },
            _vm.hoverClass ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }